export function setBudGetText(item, unit){
    if (!unit) unit = '';
    if (!item || !item.budgetType) return '面议';
    switch(item.budgetType) {
        case '0':
            return `${unit}${item.budget}万`;
        case '1':
            return `${item.budgetLower}万~${item.budgetUpper}万`;
        case '2':
            return '面议';
        default:
            return '面议';
    }
}

export function setDimPhone(phone){
    const str = String(phone).trim();
    if (!/^1[3-9]\d{9}$/.test(str)) {
        // 非标准手机号，返回原值或全脱敏
        return str.length > 6 
        ? str.substring(0, 3) + '****' + str.substring(str.length - 4)
        : str.replace(/./g, '*');
    }
    return str.substring(0, 3) + '****' + str.substring(7);
}

export function formatDate(datetimeStr) {
  if (!datetimeStr) return '';
  return datetimeStr.split(' ')[0];
}


// WEBPACK FOOTER //
// ./src/utils/filter.js